<template>
	<BusinessToCustomerInvoicesTable @failed-fetch="handleFetchError" v-if="userStore.currBusiness && userStore.currBusiness.apifattura_id" />
	<EpsonReceiptsTable @failed-fetch="handleFetchError" :class="{'mt-30': userStore.currBusiness && userStore.currBusiness.apifattura_id}" />
	<DailyClosuresTable @failed-fetch="handleFetchError" class="mt-30" />
	<ApiscontrinoReceiptsTable @failed-fetch="handleFetchError" class="mt-30" v-if="userStore.currBusiness && userStore.currBusiness.apiscontrino_id" />
</template>

<script>
import BusinessToCustomerInvoicesTable from "@/console-new/components/config/administration/BusinessToCustomerInvoicesTable.vue";
import EpsonReceiptsTable from "@/console-new/components/config/administration/EpsonReceiptsTable.vue";
import ApiscontrinoReceiptsTable from "@/console-new/components/config/administration/ApiscontrinoReceiptsTable.vue";
import DailyClosuresTable from "@/console-new/components/config/administration/DailyClosuresTable.vue";
import {useUserStore} from "@/user/stores";
import {useNotificationStore} from "@/shared/stores";

export default {
	setup() {
		let userStore = useUserStore();
		const notificationStore = useNotificationStore();

		return { userStore, showNotification: notificationStore.showNotification };
	},
	name: "TaxationTablesContainer",
	components: {BusinessToCustomerInvoicesTable, EpsonReceiptsTable, ApiscontrinoReceiptsTable, DailyClosuresTable},
	methods: {
		handleFetchError(details) {
			if(details && details !== 'not_connected') {
				let msg = details === 'auth_denied' ? 'auth-denied-error' : 'generic-fail';
				if(details === 'refund_limit_exceeded') {
					msg = 'refund-limit-exceeded-error';
				}
				this.showNotification(msg);
			}
		},
	},
	mounted() {
		if(!this.userStore.businessUsers || !Object.keys(this.userStore.businessUsers).length) {
			this.userStore.getBusinessUsers();
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.userStore.getBusinessUsers();
			}
		}
	}
}
</script>

<style scoped lang="scss">

</style>